import { useEffect, useState, type Dispatch, type SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';

import { useCustomAppClient } from 'api/custom-client';

import type { CopilotModelResponse } from 'app/modules/wallforming/components/copilot/types/copilotTypes';

export const useCopilotModel = (setError: Dispatch<SetStateAction<string | null>>) => {
    const { t } = useTranslation();
    const getCopilotModel = useCustomAppClient<CopilotModelResponse>();
    const [modelName, setModelName] = useState<string | null>(null);

    useEffect(() => {
        let isCurrent = true;
        void getCopilotModel({ url: '/copilot/model', method: 'GET' })
            .then(({ model }) => {
                if (isCurrent) {
                    setModelName(model);
                }
            })
            .catch(() => {
                if (isCurrent) {
                    setModelName(null);
                    setError(t('copilotModelUnavailable'));
                }
            });

        return () => {
            isCurrent = false;
        };
    }, [getCopilotModel, setError, t]);

    return modelName;
};
